const routes = {
  home: "/",
  forgot: "/forgot",
  changePassword: "/change-password",
  logout: "/logout"
};

export { routes };
